import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IContact } from '../../../models/contact.model';

@Injectable({ providedIn: 'root' })
export class BaryContactUtil {
  constructor(protected translateService: TranslateService) {}

  writeContact(value: IContact): string {
    let result = '';
    if (value.civility && value.lastName) {
      result += this.translateService.instant('baryApp.Civility.' + value.civility) + ' ';
    }
    if (value.lastName) {
      result += value.lastName + ' ';
    }
    if (value.firstName) {
      result += value.firstName;
    }

    if (result !== '' && value.mail) {
      result += '<br/>' + value.mail;
    }
    if (result !== '' && value.phone) {
      result += '<br/>' + value.phone;
    }

    return result;
  }
}
